export default __webpack_public_path__ + "static/pizza-36f12681bd1392381408a337a8ec4128.png";